import React from 'react'

import { useAvailableApplications } from '~/hooks/useAvailableApplications'
import { useRouteParams } from '~/hooks/useRouteParams'
import { type Application } from '~/utils'

export const useCurrentApplication = () => {
  const { appRootPath } = useRouteParams()
  const applications = useAvailableApplications()

  return React.useMemo<Application | undefined>(
    () =>
      applications.find(
        (application) => application.rootPath === `/${appRootPath}`,
      ),
    [appRootPath, applications],
  )
}
